<div
  class="d-flex flex-column align-items-center h-100 w-100 justify-content-center px-4 py-4 modal-main"
>
  <div class="header mt-1 mb-5 w-100">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        (click)="navigateBack()"
      />
      <h1 class="modal-title m-auto">{{ 'ACCOUNT_SETTING' | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="mb-5">
    <p class="text-center heading-one">{{ 'NEW_PASSWORD' | translate }}</p>
    <p class="paragraph-text text-center">
      {{ 'PLEASE_ENTER_NEW_PASSWORD' | translate }}
    </p>
  </div>

  <div
    class="d-flex flex-column justify-content-start w-100 px-3 form-container"
  >
    <form class="" [formGroup]="newPasswordForm" (ngSubmit)="updatePassword()">
      <div class="rounded-top">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ 'OLD_PASSWORD' | translate }}</mat-label>
          <input
            matInput
            [type]="hideOld ? 'password' : 'text'"
            formControlName="oldPassword"
            (keydown.space)="$event.preventDefault()"
            [ngClass]="hideOld ? 'text-hide' : 'text-visible'"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideOld = !hideOld"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hideOld"
          >
            <img
              [src]="
                hideOld
                  ? '/assets/svg/ico-eye.svg'
                  : '/assets/svg/eye-off-outline.svg'
              "
              class="pointer-cursor eye-icon"
            />
          </button>
        </mat-form-field>
      </div>
      <div class="rounded-top">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ 'NEW_PASSWORD' | translate }}</mat-label>
          <input
            matInput
            [type]="hideNew ? 'password' : 'text'"
            formControlName="newPassword"
            (keydown.space)="$event.preventDefault()"
            [ngClass]="hideNew ? 'text-hide' : 'text-visible'"
          />
          <button
            mat-icon-button
            type="button"
            matSuffix
            (click)="hideNew = !hideNew"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hideNew"
            [ngClass]="hideNew ? 'text-hide' : 'text-visible'"
          >
            <img
              [src]="
                hideNew
                  ? '/assets/svg/ico-eye.svg'
                  : '/assets/svg/eye-off-outline.svg'
              "
              class="pointer-cursor eye-icon"
            />
          </button>
          <mat-error
            *ngIf="
              formInstance?.newPassword?.invalid &&
              formInstance?.newPassword?.dirty
            "
          >
            {{
              'PASSWORD_MUST_FULLFILL_ALL_THE_MENTIONED_REQUIREMENTS' | translate
            }}
          </mat-error>
          <mat-error
            class="pt-1"
            *ngIf="
              formInstance?.newPassword?.errors?.password?.restrictedCharacters
            "
          >
            {{ 'ONLY_MENTIONED_SPECIAL_CHARACTERS_ARE_ALLOWED' | translate }}
          </mat-error>
        </mat-form-field>

        <div
          *ngIf="formInstance?.newPassword.dirty"
          class="password-steps ml-2 mb-1 mt-4"
          [ngClass]="
            formInstance?.newPassword?.errors?.password
              ? ''
              : 'hide-password-policy'
          "
        >
          <p
            [ngClass]="
              formInstance?.newPassword?.errors?.minlength ||
              formInstance?.newPassword?.errors?.maxlength ||
              formInstance?.newPassword?.errors?.required
                ? 'password-policy'
                : 'password-policy-checked'
            "
          >
            {{ 'EIGHT_TO_TWENTY_CHARACTERS' | translate }}
          </p>
          <p
            [ngClass]="
              formInstance?.newPassword?.errors?.password?.upperCase
                ? 'password-policy'
                : 'password-policy-checked'
            "
          >
            {{ 'ATLEAST_ONE_UPPERCASE_LETTER' | translate }}
          </p>
          <p
            [ngClass]="
              formInstance?.newPassword?.errors?.password?.lowerCase
                ? 'password-policy'
                : 'password-policy-checked'
            "
          >
            {{ 'ATLEAST_ONE_LOWERCASE_LETTER' | translate }}
          </p>
          <p
            [ngClass]="
              formInstance?.newPassword?.errors?.password?.number
                ? 'password-policy'
                : 'password-policy-checked'
            "
          >
            {{ 'ATLEAST_ONE_NUMBER' | translate }}
          </p>
          <p
            [ngClass]="
              formInstance?.newPassword?.errors?.password?.specialCharacter
                ? 'password-policy'
                : 'password-policy-checked'
            "
          >
            {{ 'ATLEAST_ONE_SPECIAL_CHARACTER' | translate }}
          </p>
        </div>
      </div>
      <div class="rounded-top">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>{{ 'REENTER_NEW_PASSWORD' | translate }}</mat-label>
          <input
            matInput
            [type]="hideConfirm ? 'password' : 'text'"
            formControlName="confirmPassword"
            (keydown.space)="$event.preventDefault()"
            [ngClass]="hideConfirm ? 'text-hide' : 'text-visible'"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideConfirm = !hideConfirm"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hideConfirm"
          >
            <img
              [src]="
                hideConfirm
                  ? '/assets/svg/ico-eye.svg'
                  : '/assets/svg/eye-off-outline.svg'
              "
              class="pointer-cursor eye-icon"
            />
          </button>
          <mat-error
            *ngIf="formInstance?.confirmPassword?.errors?.passwordMismatch"
            class="pb-3"
            >{{ 'BOTH_PASSWORD_SHOULD_MATCH' | translate }}</mat-error
          >
        </mat-form-field>
      </div>
    </form>
  </div>
  <div
    class="row w-100 px-3"
    [ngClass]="
      formInstance?.confirmPassword?.value.length > 20 ? 'mt-3' : 'mt-1'
    "
  >
    <div class="w-100">
      <button
        class="btn btn-danger update-btn px-3"
        type="submit"
        [disabled]="!newPasswordForm.valid"
        tabindex="0"
        (click)="updatePassword()"
      >
        {{ 'UPDATE' | translate}}
      </button>
    </div>
  </div>
</div>
